import script from "./PasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./PasswordPage.vue?vue&type=style&index=0&id=80aaa244&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80aaa244"]])

export default __exports__